import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { withNamespaces } from 'react-i18next'
import i18next from 'i18next';

import PayBankContainer from './payBank/PayBankContainer'
import VacationBankContainer from './vacationBank/VacationBankContainer'
import { getAccessTab } from '../../utils/menuHelper';
import * as keyMenu from '../../scripts/KeyMenu';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper
    },
}));

function TabPanelBankBalance({ t }) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [index, setIndex] = React.useState(0);
    const [hasPayBank, setHasPayBank] = React.useState(false);
    const [hasVacationBank, setHasVacationBank] = React.useState(false);
    const [isDenied, setIsDenied] = React.useState(false);

    useEffect(() => {
        validateAccessTab();
    }, [])

    const validateAccessTab = () => {

        const isTabPayBank = getAccessTab(keyMenu.TAB_BANKBALANCEOTHERS);
        const isTabVacationBank = getAccessTab(keyMenu.TAB_BANKBALANCEVACATION);

        setHasPayBank(isTabPayBank);
        setHasVacationBank(isTabVacationBank);
        setIsDenied(!isTabPayBank && !isTabVacationBank);

        if (!isTabPayBank) {
            setIndex(1);
        }
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const payBankClick = () => {
        setIndex(0);
    }

    const vacationBankClick = () => {
        setIndex(1);
    }

    return (
        <React.Fragment>
            <div data-id="headerBankBalance" className={classes.root}>
                {isDenied && i18next.t("bankBalance:alert.noAccess")}
                {!isDenied && <AppBar position="static" color="default" id="appBarTitle">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="standard"
                        indicatorColor="primary"
                        textColor="primary"
                        className={"TabPage"}
                    >
                        {hasPayBank && <Tab className={"TabPageButton"} label={t('bankBalance:tabPanel.payBank')} onClick={payBankClick} />}
                        {hasVacationBank && <Tab className={"TabPageButton"} label={t('bankBalance:tabPanel.vacationBank')} onClick={vacationBankClick} />}
                    </Tabs>
                </AppBar>}
            </div>
            {!isDenied && index == 0 && hasPayBank && <PayBankContainer />}
            {!isDenied && index == 1 && hasVacationBank && <VacationBankContainer/>}
        </React.Fragment>
    );
}

export default withNamespaces(['bankBalance'], { wait: true })(TabPanelBankBalance);